import React from 'react';
import { TextField } from '@fluentui/react';

import {
    inputBoxStyle,
    inputBoxTextStyle,
    inputBoxWarningStyle,
    labelFontStyle,
    warningStyle
} from './styles/Configuration.styles';
import { labelConstants } from '../core/constants';
import { IsCandidateMode, IsHiddenMode, IsProctorMode, IsHiddenUser } from 'Utils/Utils';
import { Constants } from '../core/constants';


interface DisplayNameFieldProps {
    setName(name: string): void;
    name: string;
    setEmptyWarning(isEmpty: boolean): void;
    isEmpty: boolean;
}

const TextFieldStyleProps = {
    wrapper: {
        height: '2.3rem'
    },
    fieldGroup: {
        height: '2.3rem'
    }
};

export default (props: DisplayNameFieldProps): JSX.Element => {
    const onNameTextChange = (event: any): void => {

        if (IsProctorMode() && !IsHiddenUser(event.target.value)) 
            props.setName(`${Constants.HIDDEN_USER_PREFIX}${event.target.value}`);
        else
            props.setName(event.target.value);

        if (event.target.value) {
            props.setEmptyWarning(false);
        } else {
            props.setEmptyWarning(true);
        }
    };

    return (
        <div>
            <div className={labelFontStyle}>Name</div>
            <TextField
                autoComplete="off"
                inputClassName={inputBoxTextStyle}
                ariaLabel={labelConstants.ChooseName}
                borderless={true}
                className={props.isEmpty ? inputBoxWarningStyle : inputBoxStyle}
                onChange={onNameTextChange}
                id="name"
                placeholder={labelConstants.EnterName}
                defaultValue={props.name}
                styles={TextFieldStyleProps}
                disabled={IsCandidateMode() || IsHiddenMode()}
                type={IsHiddenMode() ? 'password' : ''}
            />
            {props.isEmpty && (
                <div role="alert" className={warningStyle}>
                    {' '}
                    Name cannot be empty{' '}
                </div>
            )}
        </div>
    );
};